import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'patterns',
  standalone: true,
})
export class PatternsPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(patterns: string[], activeLang?: string) {
    if (!patterns || patterns.length === 0) return null;

    return patterns
      .map(p => this.translocoService.translate(p, {}, activeLang))
      .join(', ');
  }
}
